import { get, globalPut } from "api";

// HOW FAR THE RECORDS HAVE CAUGHT UP WITH THE SITE, per project.
//
// The read answers { percent, mayChange } - the second half matters, because
// the control has to be readable by everyone on the project and writable only
// by the owner, a company admin, a super admin, or a member whose role is
// Admin and who holds admin-section access. Asking the server who may change
// it beats guessing from flags in the browser, which is how a control ends up
// enabled for somebody the API will refuse.
export const getReportingCatchUp = (projectId) =>
  get(`/projects/${projectId}/reporting-catchup`);

// `percent` is 0-100, or null for "nobody has assessed this". NULL IS NOT
// ZERO: zero says none of the records are level with the site, null says
// nobody has judged it, and the digest prints different sentences for each.
export const setReportingCatchUp = (projectId, percent) =>
  globalPut(`/projects/${projectId}/reporting-catchup`, { percent });
